exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scanViewWrapper {\n  position: fixed;\n  left:0;top:0;right:0;bottom:0;\n  background-color: black;\n  z-index:1111;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/inventory/scanview.component.css
// module id = 440
// module chunks = 0